<div class="mp-form-page">
  <div class="mp-form-page__inner">

    <div class="mp-form-card">

      <!-- Card header -->
      <div class="mp-form-card__header">
        <div class="mp-form-card__header-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
          </svg>
        </div>
        <div>
          <h1 class="mp-form-card__title">Ajouter un mode de passation</h1>
          <!-- Pour edit : Modifier un mode de passation -->
          <p class="mp-form-card__subtitle">Renseignez les informations et les délais du mode de passation.</p>
        </div>
      </div>

      <!-- Form body -->
      <form
        [formGroup]="modePassationMarcheForm"
        (ngSubmit)="saveModePassationMarche()"
        class="mp-form-card__body"
      >

        <!-- Section : Identification -->
        <div class="mp-form__section">
          <p class="mp-form__section-title">Identification</p>
          <div class="mp-form__row mp-form__row--triple">
            <app-select
              label="Type de mode de passation"
              formControlName="typeModePassationMarche"
              [options]="typeModePassations"
            />
            <app-input
              label="Mode de passation de marché"
              type="text"
              formControlName="modePassationMarche"
            />
            <app-input
              label="Mode"
              type="text"
              formControlName="mode"
            />
          </div>
        </div>

        <!-- Section : Délais principaux -->
        <div class="mp-form__section">
          <p class="mp-form__section-title">Délais principaux</p>
          <div class="mp-form__row">
            <app-input label="Délai de publication" type="number" formControlName="delaiPublication"/>
            <app-input label="Seuil" type="number" formControlName="seuil"/>
          </div>
          <div class="mp-form__row">
            <app-input label="Montage (en jours)" type="number" formControlName="montage"/>
            <app-input label="Lancement (en jours)" type="number" formControlName="lancement"/>
          </div>
          <div class="mp-form__row">
            <app-input label="Ouverture" type="number" formControlName="ouverture"/>
            <app-input label="Evaluation" type="number" formControlName="evaluation"/>
          </div>
          <div class="mp-form__row">
            <app-input label="Négociation gré à gré" type="number" formControlName="negociationGreGre"/>
            <app-input label="Avis de l'organe de contrôle" type="number" formControlName="organeControle"/>
          </div>
          <div class="mp-form__row">
            <app-input label="Vérification de la disponibilité de crédits" type="number" formControlName="verificationDisponibiliteCredits"/>
            <app-input label="Notification des résultats" type="number" formControlName="notificationResultats"/>
          </div>
        </div>

        <!-- Section : Contrat -->
        <div class="mp-form__section">
          <p class="mp-form__section-title">Élaboration et signature du contrat</p>
          <div class="mp-form__row">
            <app-input label="Délai d'attente et élaboration du contrat" type="number" formControlName="delaiAttenteElaborationContrat"/>
            <app-input label="Examen juridique du projet de contrat par la CJC" type="number" formControlName="examenJuridiqueProjetContratCJC"/>
          </div>
          <div class="mp-form__row">
            <app-input label="Signature de contrat par le titulaire" type="number" formControlName="signatureContratTitulaire"/>
            <app-input label="Visa du contrat par le juriste" type="number" formControlName="visaContratJuriste"/>
          </div>
          <div class="mp-form__row">
            <app-input label="Visa du contrat par le DM" type="number" formControlName="visaContratDM"/>
            <app-input label="Visa du contrat par la DFC" type="number" formControlName="visaContratDFC"/>
          </div>
          <div class="mp-form__row">
            <app-input label="Visa du contrat par la DCGIS" type="number" formControlName="visaContratDCGIS"/>
            <app-input label="Visa du contrat par la DGA" type="number" formControlName="visaContratDGA"/>
          </div>
          <div class="mp-form__row">
            <app-input label="Signature de contrat par le DG" type="number" formControlName="signatureContratDG"/>
            <app-input label="Notification du contrat au titulaire par le SC" type="number" formControlName="notificationContratTitulaireSC"/>
          </div>
          <div class="mp-form__row mp-form__row--single">
            <app-input label="Délai de délivrance des OS" type="number" formControlName="delaiDelivranceOS"/>
          </div>
        </div>

        <!-- Total -->
        <div class="mp-total-banner">
          <span class="mp-total-banner__label">Total des délais</span>
          <span class="mp-total-banner__value">{{ totalDelais }} jours</span>
        </div>

        <!-- Actions -->
        <div class="mp-form__actions">
          <app-ui-button
            label="Retour"
            variant="ghost"
            size="md"
            type="button"
            iconLeft="arrow_back"
            [routerLink]="[
              '/',
              routeAlias.parameters.home,
              routeAlias.parameters.marches.home,
              routeAlias.parameters.marches.mode_passation_marches.home
            ]"
          ></app-ui-button>
          <app-ui-button
            label="Enregistrer"
            variant="primary"
            size="md"
            iconLeft="save"
            type="submit"
            [loading]="isLoading"
            [disabled]="isLoading || modePassationMarcheForm.invalid"
          ></app-ui-button>
          <!-- Pour edit : label="Mettre à jour" iconLeft="check" -->
        </div>

      </form>
    </div>
  </div>
</div>